import { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactSelect, { components as selectComponents } from 'react-select';
import { FiChevronDown } from 'react-icons/fi';

import { DropdownContainer, buildDropdownStyles, VARIANTS } from './styles';

const optionPropTypes = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
});

const propTypes = {
  options: PropTypes.arrayOf(optionPropTypes).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
};

const defaultProps = {
  value: null,
  placeholder: 'Selecione',
  variant: 'pill',
};

const DropdownIndicator = props => (
  <selectComponents.DropdownIndicator {...props}>
    <FiChevronDown size={16} />
  </selectComponents.DropdownIndicator>
);

/**
 * Select avulso de UI (fora de formulário). Entrega e devolve o `value` cru,
 * e não o objeto de opção do react-select, para o consumidor não precisar
 * conhecer esse detalhe.
 */
const SelectDropdown = ({
  options,
  value,
  onChange,
  ariaLabel,
  placeholder,
  variant,
  ...rest
}) => {
  const styles = useMemo(() => buildDropdownStyles(variant), [variant]);

  return (
    <DropdownContainer>
      <ReactSelect
        options={options}
        value={options.find(option => option.value === value) || null}
        onChange={option => onChange(option ? option.value : null)}
        aria-label={ariaLabel}
        placeholder={placeholder}
        isSearchable={false}
        menuPlacement="auto"
        components={{ DropdownIndicator }}
        styles={styles}
        {...rest}
      />
    </DropdownContainer>
  );
};

SelectDropdown.propTypes = propTypes;
SelectDropdown.defaultProps = defaultProps;

export default SelectDropdown;
